import { Injectable } from "@angular/core";
import { resolve } from "dns";
import { BehaviorSubject, Observable, Subject, Subscription } from "rxjs";
import { HTTPService } from 'src/app/services/http.service';
import { ObjectUtil } from "../system-utils/utils/ObjectUtil";

export interface product{
    columnName?:string,
    type?:string,
    required?:boolean,
    enum?:string[],
    child?:product[];
    minLength?:number;
    maxLength?:number;
    isattribute:boolean;
    isopen?:boolean;
    level?:number;
    multi:boolean;
    isvisible:boolean;
}

@Injectable({
    providedIn: 'root'
  })
  
  export class AmazonServices {
  
  
  getContent(resource: any) {
    return new Promise((resolve,reject)=>{
       this.http.get(resource).subscribe((data:Object)=>{
          resolve(data);
       });
    });
  }
  
  sub:Promise<any>;  
  amazonSchema  = {}
  products:BehaviorSubject<product[]> = new BehaviorSubject(null);
  data:product[] = [];
  constructor(private http:HTTPService) { 
        
    this.loadAmazonSchema2().then(x=>{
      
        let product = this.amazonSchema['definitions']['Product'];
        
        let required = product['required'];
        let newProduct:product = {
          columnName: product['title'],
          isattribute: false,
          type: 'object',
          required: product['required'],
          child:[],
          level:0,
          multi:false,
          isvisible:true
        } 
    
        
        let a = this.loadData(product, required, 0, newProduct);
        let p:product[] = [];
        p.push(newProduct);
        this.products.next(p);
        this.data = p;
        
    });

  
  
}

ngOnDestroy(){
    
}

getAmazonData(){
  return this.products.asObservable();
}

loadRef(ref:string){
    return this.amazonSchema['definitions'][ref.replace('#/definitions/','')];
}

findRef(data:object){
  let ref = null;
  if ( data['allOf'] !=null){
     let allOf = data['allOf'];
     if ( allOf != null) {
       if ( allOf instanceof Array){
         let hasRef = false;
         allOf.forEach(d=>{
           if ( Object.keys(d).indexOf('$ref') > -1){
             ref = d['$ref'];
             hasRef = true;
             return;
           }
           if ( (Object.keys(d).indexOf('items')) > -1 ){
                ref = this.findRef(d['items']);
           }
         });
         
         if ( !hasRef ){
            allOf.forEach(k=>{
              if ( Object.keys(k).indexOf('allOf')>-1){
                ref = this.findRef(k);
              }
            })
         }

       }else{
          if ( Object.keys(allOf).indexOf('$ref')>-1){
            ref =  allOf['$ref'];
          }else{
            ref = this.findRef(allOf);
          }
       }        
     }
  }else{
     if (  Object.keys(data).indexOf('$ref')>-1 ){
        ref = data['$ref'];
     }
  }
  return ref;
}

findEnum(data:object){

  let options = null;
  if ( data['allOf'] !=null){
     let allOf = data['allOf'];
     if ( allOf != null) {
       if ( allOf instanceof Array){
         let hasRef = false;
         allOf.forEach(d=>{
           if ( Object.keys(d).indexOf('enum') > -1){
            options = d['enum'];
             hasRef = true;
             return;
           }

           if ( (Object.keys(d).indexOf('items')) > -1 ){
            options = this.findRef(d['items']);
          }
         })
         if ( !hasRef ){
            allOf.forEach((k:string[])=>{
              options = this.findEnum(k);
            })
         }

       }else{
          if ( Object.keys(allOf).indexOf('enum')>-1){
            options =  allOf['enum'];
          }else{
            options = this.findEnum(allOf);
          }
       }        
     }
  }else{
    if (  Object.keys(data).indexOf('enum')>-1 ){
      options = data['enum'];
   }
  }
  return options;
}

loadData(data:object, required:string[], level:number, product:product){
    
    let newData = product;
    let properties:object = data['properties'];
    let type = data['type'];

    let ref = null;
    let options = []
    if ( data['allOf'] != null ){
      ref = this.findRef(data);
      options =  this.findEnum(data) == null? [] : this.findEnum(data);
    }
    
    let def = false;
    if ( ref != null ){
      if ( ref.startsWith('http://www.jsonix.org/jsonschemas/w3c/2001/XMLSchema.jsonschema#/definitions/')){
        type = ref.replace('http://www.jsonix.org/jsonschemas/w3c/2001/XMLSchema.jsonschema#/definitions/','');
      }else{
        type = null;
        def = true;
      }
    }

    

    if ((properties != null && Object.keys(properties).length > 0)  || def ){

      if ( def ){
        let dataRef = this.loadRef(ref);

        let title = data['title'];
        
        let elementName:Object = data['elementName'];
        let attributeName:Object = data['attributeName'];
        let typeName:Object = data['typeName'];
        let localPart = null;
        

        if ( elementName != null ){
            if ( Object.keys(elementName).indexOf('localPart') > -1){
                localPart = elementName['localPart'];
            }
        }
        let isAttribute = false;
        if ( attributeName != null ){
            if ( Object.keys(attributeName).indexOf('localPart') > -1){
                localPart = attributeName['localPart'];
                isAttribute = true;
                localPart = "@"+localPart;
            }
        }

        if ( dataRef['required']!= null ){
            required = dataRef['required'];
        }
        
        let newProduct:product = {
            columnName: localPart == null? title:  localPart,
            isattribute: isAttribute,
            type: type,
            required: required.indexOf(title)>-1? true: false,
            child:[],
            level:level,
            multi:false,
            enum: options,
            isvisible:true
        }

        if ( isAttribute){
          newData = this.loadData( dataRef, required, level, newProduct);
          return newData;
        }

        newData = this.loadData( dataRef, required, level, newProduct);
        //newProduct.child.push(newData);
        return newData;
      }else{
        Object.keys(properties).forEach(prop=>{

          let object:object = properties[prop];
          newData = this.loadData(object,required,level+1,product);
          product.child.push(newData);
          /*let title = data['title'];
          let elementName:Object = data['elementName'];
          let localPart = null;
          

          if ( elementName != null ){
              if ( Object.keys(elementName).indexOf('localPart') > -1){
                  localPart = elementName['localPart'];
              }
          }

          if ( data['required']!= null ){
              required = data['required'];
          }
          
          
          let newProduct:product = {
              columnName: localPart == null? title:  localPart,
              isattribute: false,
              type: type,
              required: required.indexOf(title)>-1? true: false,
              child:[],
              level:level,
              multi:options.length > 0 ? true: false,
              enum: options
          }
          newData.child.push(newProduct);
          return newData;*/
        })
        return product; 
      }
      return newData;
    }else{

        if ( product.isattribute ){
            product.enum = options;
            return product;
        }else{
          let title = data['title'];
          let elementName:Object = data['elementName'];
          //let typeName:Object = data['typeName'];
          let localPart = null;
          

          if ( elementName != null ){
              if ( Object.keys(elementName).indexOf('localPart') > -1){
                  localPart = elementName['localPart'];
              }
          }

          
          //if ( typeName != null ){
            //if ( Object.keys(typeName).indexOf('localPart') > -1){
              //  localPart = typeName['localPart'];
            //}
          //}
        


          if ( data['required']!= null ){
              required = data['required'];
          }
          
          if ( title == null && localPart == null){
              title = product.columnName;
          }
          
          let newProduct:product = {
              columnName: localPart == null? title:  localPart,
              isattribute: false,
              type: type,
              required: required.indexOf(title)>-1? true: false,
              child:[],
              level:level,
              multi:false,
              enum: options,
              isvisible:true
          }
          
          return newProduct;
        }
        
    }
}


loadAmazonSchema2(){
    return new Promise((resolve,reject)=>{
      this.http.getAsset(`assets/amazon-xsd/generated.jsonschema`).subscribe(data =>{
         this.amazonSchema  = JSON.parse(data);
         resolve('resolved');
         },error=>{
           reject(error)
         }
       )
     })
      
   }

   saveProduct(categoryName, codecontract, idSeller, codeCompany, categoryID,codeProduct,amazonJson, variationJson){

    let ob = {            
      "codecompany": codeCompany,
      "categoryID": categoryID,      
      "categoryName":categoryName,      
      "amazonJson": amazonJson,
      "variationJson": variationJson,
      "codeProduct": codeProduct,
      "idSeller": idSeller,
      "codecontract": codecontract
    }
    

    return new Promise((resolve,reject)=>{
      this.http.post(ob,'AmazonServices/saveProduct',false,true,false).subscribe(data=>{
        if ( data["resultado"]){

        
            
          }
      });
    
    });
  }

  

  getSchema(category,codecompany){

    return new Promise((resolve,reject)=>{


      let ob = {
        "entityName":"Mktpactivecompanies",
        "sql":`SELECT A.CLIENTID
              FROM MKTPACTIVECOMPANIES A
              WHERE A.CODECOMPANY=${codecompany}
              AND A.CODEMKTP=62`
      }
       
      this.http.post(ob,'JsonBrokerServices/findnative',false,true,true).subscribe(con=>{
           
          if( ObjectUtil.isNotEmpty(con['SQL'])){
  
           let sellerId=   con['SQL'][0]['CLIENTID'];

           let expressao = 'getRequestDataAmazon(\"https://sellingpartnerapi-na.amazon.com/definitions/2020-09-01/productTypes/'+category+'?sellerId='+sellerId+'+&marketplaceIds=A2Q3Y263D00KWC&requirements=LISTING&locale=pt_BR\",GET,null,false)';
           
           let obHeader = {
             "expressao": expressao,
             "novo": true,
             "codecompany": codecompany,
             "codemktp": 62,
             "codecontract": 0,
             "values":[
               {
                 'key':'@CODECOMPANY',
                 'value':codecompany
               },
               {
                 'key':'@CODEMKTP',
                 'value':62
               }
             ] 
           }
     
           this.http.post(obHeader,'FormulaServices/test', true,true,false).subscribe(data=>{
               let body =  JSON.parse(data['resultado']);
               resolve(body);
           },error=>{
             throw error;
           });
            
        
          }
      });

     
    });
   }

   getRestrictions(asin,condition,codecompany){

    return new Promise((resolve,reject)=>{
      
      let expressao = 'getRequestDataAmazon(\"https://sellingpartnerapi-na.amazon.com/listings/2021-08-01/restrictions?marketplaceIds=A2Q3Y263D00KWC&sellerId=getActiveCompanies({@CODECOMPANY},{@CODEMKTP},"CLIENTID")&asin='+asin+'&conditionType='+condition+'&reasonLocale=pt_BR\",GET,null,false)';
      
      let obHeader = {
        "expressao": expressao,
        "novo": true,
        "codecompany": codecompany,
        "codemktp": 62,
        "codecontract": 0,
        "values":[
          {
            'key':'@CODECOMPANY',
            'value':codecompany
          },
          {
            'key':'@CODEMKTP',
            'value':62
          }
        ] 
      }

      this.http.post(obHeader,'FormulaServices/test', true,true,false).subscribe(data=>{
          let body =  JSON.parse(data['resultado']);
          resolve(body);
      },error=>{
        throw error;
      });
    });
   }

   callAmazonItemPut(json){

    return new Promise((resolve,reject)=>{

      let jsonAmazon = {
        "productType": "TOOLS",
        "requirements": "LISTING",  
        "attributes": json
      };

      let expressao1 = 'getRequestDataAmazon(\"https://sellingpartnerapi-na.amazon.com/listings/2021-08-01/items/A2ZPJ4TLUOSWY8/7898566919?marketplaceIds=A2Q3Y263D00KWC&issueLocale=en_US\",PUT,'+jsonAmazon+',false)';
     // let expressao = 'getRequestDataAmazon(\"https://sellingpartnerapi-na.amazon.com/definitions/2020-09-01/productTypes/'+category+'?marketplaceIds=A2Q3Y263D00KWC&requirements=LISTING&locale=pt_BR\",GET,null,false)';
      
      let obHeader = {
        "expressao": expressao1,
        "novo": true,
        "codecompany": 3,
        "codemktp": 62,
        "codecontract": 0,
        "values":[
          {
            'key':'@CODECOMPANY',
            'value':3
          },
          {
            'key':'@CODEMKTP',
            'value':62
          }
        ] 
      }

      this.http.post(obHeader,'FormulaServices/test', true,true,false).subscribe(data=>{
        let body =  data['resultado'];
          resolve(body);
      },error=>{
        throw error;
      });
    });
   }

   generateAmazonLWAAccessToken(clientId,clientSecret,scope,codecompany){

      return new Promise((resolve,reject)=>{
        let ob = {
          "expressao": "getRequestData(Token_IAM_Role,Auth,{@PARAM},POST,null,null,62)",
          "novo": true,
          "codecompany": codecompany,
          "codemktp": 62,
          "codecontract": 0,
          "values":[
            {
              'key':'@PARAM',
              'value':`?grant_type=client_credentials&scope=${scope}&client_id=${clientId}&client_secret=${clientSecret}`
            },
            {
              'key':'@CODECOMPANY',
              'value':codecompany
            },
            {
              'key':'@CODEMKTP',
              'value':62
            }
          ] 
        }
        
        this.http.post(ob,'FormulaServices/test', true,true,false).subscribe(data=>{
            resolve(data);
        },error=>{
            throw error;
        },()=>{
        })

      })

   }


   getHeader(method,url,accessToken,body,sessionToken,codecompany,activecompanies){

    return new Promise((resolve,reject)=>{
      let amazonHeader = body?
          `getAmazonHeader(url=${url},accessToken=${accessToken},secretAccessKey=${activecompanies['SECRETACCESSKEY']},tipo=${method},regionName=us-east-1,serviceName=execute-api,securityToken=${sessionToken},accesKeyId=${activecompanies['ACCESSKEYID']},content=${body})`:
          `getAmazonHeader(url=${url},accessToken=${accessToken},secretAccessKey=${activecompanies['SECRETACCESSKEY']},tipo=${method},regionName=us-east-1,serviceName=execute-api,securityToken=${sessionToken},accesKeyId=${activecompanies['ACCESSKEYID']})`


      let obHeader = {
        "expressao": amazonHeader,
        "novo": true,
        "codecompany": codecompany,
        "codemktp": 62,
        "codecontract": 0,
        "values":[
          {
            'key':'@CODECOMPANY',
            'value':codecompany
          },
          {
            'key':'@CODEMKTP',
            'value':62
          }
        ] 
      }

      this.http.post(obHeader,'FormulaServices/test', true,true,false).subscribe(data=>{
          let header =  data['resultado'];
          resolve(header);
      },error=>{
        throw error;
      });
    });
   }
    
}

